/**
 * Text used in the regulatory info page.
 */
export const RegulatoryInfoMessages = {
    /**
     * (43)
     */
    isProvidingInterconnectedService:
        'Does the Applicant propose to provide service interconnected to the public telephone network?',

    /**
     * (44)
     */
    isForeignGovernment:
        'Is the Applicant a foreign government or the representative of any foreign government?',

    /**
     * (45)
     */
    isAlien: 'Is the Applicant an alien or the representative of an alien?',

    /**
     * (46)
     */
    isAlienCorporation:
        'Is the Applicant a corporation organized under the laws of any foreign government?',

    /**
     * (47)
     */
    isAlienOfficer:
        'Is the Applicant a corporation of which more than one-fifth of the capital stock is owned of record or voted by aliens or their representatives or by a foreign government or representative thereof or by any corporation organized under the laws of a foreign country?',
    /**
     * (48)
     */
    isAlienControl:
        'Is the Applicant directly or indirectly controlled by any other corporation of which more than one-fourth of the capital stock is owned of record or voted by aliens or their representatives, or by a foreign government or representative thereof, or by any corporation organized under the laws of a foreign country?',

    /**
     * (49)
     */
    isRevoked:
        'Has the Applicant or any party to this application had any FCC station authorization, license or construction permit revoked or had any application for an initial, modification or renewal of FCC station authorization, license, or construction permit denied by the Commission?',

    /**
     * (50)
     */
    isConvictedFelon:
        'Has the Applicant or any party to this application, or any party directly or indirectly controlling the Applicant, ever been convicted of a felony by any state or federal court?',

    /**
     * (51)
     */
    isCourtAdjudicated:
        'Has any court finally adjudged the Applicant or any party directly or indirectly controlling the Applicant guilty of unlawfully monopolizing or attempting unlawfully to monopolize radio communication, directly or indirectly, through control of manufacture or sale of radio apparatus, exclusive traffic arrangement, or any other means or unfair methods of competition?',

    /**
     * (52)
     */
    isAeronautical:
        'I certify that the station will be located on property of the airport to be served, and, in cases where the airport does not have a control tower, RCO, or FAA flight service station, that I have notified the owner of the airport and all aviation service organizations located at the airport within ten days prior to application.',

    /**
     * (53a)
     */
    isMultichannel:
        'Will the requested facilities be used to provide multichannel video programming service?',

    /**
     * (53b)
     */
    isCableTv:
        'If the answer to question 53a is ‘Y’, does the Applicant operate, control or have an attributable interest (as defined in 47 CFR § 27.1202) in a cable television system whose franchise area is located within the geographic service area of the requested facilities? Note: If the answer to question 53b is ‘Y’, attach an exhibit explaining how the Applicant complies with 47 CFR § 27.1202 or justifying a waiver of that rule. If a waiver of the Commission Rule(s) is being requested, Item 11a must be answered ‘Y’.',

    /**
     * (54)
     */
    isCompliantSection271203:
        '(For EBS only) Does the Applicant comply with the programming requirements contained in 47 CFR § 27.1203?  Note: If the answer to item 54 is ‘N’, attach an exhibit explaining how the Applicant complies with 47 CFR § 27.1203 of the Commission’s Rules or justifying a waiver of that rule. If a waiver of the Commission Rule(s) is being requested, Item 11a must be answered ‘Y’.',

    /**
     * (55)
     */
    isCompliantSection27Others:
        '(For BRS and EBS) Does the Applicant comply with 47 CFR §§ 27.50, 27.55, and 27.1221?  <b>Note: If the answer to item 55 is ‘N’</b>, attach an exhibit justifying a waiver of that rule(s). If a waiver of the Commission Rule(s) is being requested, Item 11a must be answered ‘Y’.',

    /**
     * (56)
     */
    isRuralPartnership:
        'Is the Applicant a qualifying rural wireless partnership or a member of a qualifying rural wireless partnership?  Note: If the answer to item 56 is ‘Y’, attach an exhibit listing all members of the qualifying rural wireless partnership, including their FRN numbers.',
    /**
     * (58)
     */
    hasDiscontinuanceOfService:
        'Applicant certifies that no permanent discontinuance of service or operation, as applicable, occurred during its current license term.',

    /**
     * Expandable information text between (58)/(59)
     */
    attachAnExhibit:
        'Note: If the response to either item 57 or item 58 is ‘N’, attach an exhibit that demonstrates that over the course of the license term, the Applicant provided and continues to provide service to the public, or operated and continues to operate the license to meet the Applicant’s private business or public interest/public safety communications needs. This exhibit must include a detailed description of the Applicant’s provision of service or, when allowed under the relevant service rules or pursuant to waiver, use of the spectrum for private business or public interest/public safety communications needs, during the entire license period and address, as applicable: 1) the level and quality of service provided by the applicant (e.g., the population served, the area served, the number of subscribers, the services offered); (2) the date service commenced, whether service was ever interrupted, and the duration of any interruption or outage; (3) the extent to which service is provided to rural areas; (4) the extent to which service is provided to qualifying tribal land as defined in 47 CFR § 1.2110(e)(3)(i); and (5) any other factors associated with the level of service to the public. The licensee may note in its exhibit: 1) any grant(s) of waiver or extension of a performance deadline or license renewal subject to meeting a performance requirement; or 2) if the final performance deadline and/or expiration date for the license accelerated because the licensee did not meet an interim performance requirement.',

    /**
     * (59)
     */
    hasRegulatoryCompliance:
        'Applicant certifies that it has substantially complied with all applicable FCC rules, policies, and the Communications Act of 1934, as amended.  Note: If the response to item 59 is ‘N’, attach an exhibit explaining the circumstances and demonstrating why Applicant’s license should be renewed.',
};
